export default __webpack_public_path__ + "static/media/Snd_LowerAHelicopter.ea8da8df.mp3";